<template>
  <div class="pay-methods">
    <!-- h5 -->
    <template v-if="isH5">
      <DrawerDialog
        :showInput="false"
        :title="titleName"
        v-model="visibleDialog"
      >
        <div class="pay-content">
          <div class="pay-text">{{ $t('总计') }}</div>
          <div class="pay-money">{{ money }}</div>
          <div class="paymethod">
            <Payment
              :paymentParams="paymentParams"
              :selectCard="selectCard"
              @updatepay="updatePay"
            />
          </div>
          <div class="paybtn">
            <el-button @click="confrimPay">{{ titleName }}</el-button>
          </div>
        </div>
      </DrawerDialog>
    </template>
    <!-- pc -->
    <template v-else>
      <el-floating
        :width="widthSelectAddress"
        :title="titleName"
        :visible.sync="visibleDialog"
        :append-to-body="true"
        :close-on-click-modal="false"
        custom-class="el-floating_d-reset el-floating_d-reset_bg-color"
        icon-class="icon-outline_close"
      >
        <div class="pay-content">
          <div class="pay-text">{{ $t('总计') }}</div>
          <div class="pay-money">{{ money }}</div>
          <div class="paymethod">
            <Payment
              :paymentParams="paymentParams"
              :selectCard="selectCard"
              @updatepay="updatePay"
            />
          </div>
          <div class="paybtn">
            <el-button @click="confrimPay">{{ titleName }}</el-button>
          </div>
        </div>
      </el-floating>
    </template>
  </div>
</template>

<script>
import DrawerDialog from '@/components/DrawerDialog';
import Payment from '@/components/Pay/payment.vue';
import { mapState } from 'vuex';
import { COMMON_INFO } from '@/const/base';

export default {
  name: 'PayMethods',
  components: {
    DrawerDialog,
    Payment,
  },
  props: {
    visible: Boolean,
    titleName: String,
    money: String,
    cartId: String,
  },
  computed: {
    ...mapState({
      isH5: ({ common }) => common.isH5,
    }),
    visibleDialog: {
      get: function() {
        return this.visible;
      },
      set: function(value) {
        this.$emit('showsChange', value);
      },
    },
    paymentParams() {
      return {
        // todo
        terminalId: COMMON_INFO.TERMINAL_ID, //global和外卖单独端的terminal_id不同 18.端来源标识--terminal_id
        appversion: '', //客户端版本
        price: '', //realPayPrice，提单页进入不传， 二次小费和欠款进入必传
        aid: '', //提单页进入有选必传，二次小费和欠款进入不传
        scene: 0, //查询场景，0-提单页，1 - 欠款单还款场景，2 - 二次小费支付场景
        cartId: '', //提单页进入必传，二次小费和欠款进入不传
      };
    },
    //接口返回卡数据
    selectCard() {
      return {};
    },
  },
  model: {
    prop: 'visible',
    event: 'showsChange',
  },
  data() {
    return {
      widthSelectAddress: '470px',
      selectedCard: {},
    };
  },
  methods: {
    updatePay(val) {
      this.selectedCard = val;
    },
    confrimPay() {
      if (JSON.stringify(this.selectedCard) == '{}') {
        // 没有选择卡提示
        this.$utils.warningToast(this.$t('请选择支付方式'))
      } else {
        this.$emit('confrimPay', this.selectedCard);
        this.visibleDialog = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
<style lang="scss">
.el-floating_d-reset_bg-color{
  background: #f5f5f7;
}

</style>
